import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { ModeloVistoriaApiService } from '../../editar-modelo-vistoria/services/modelo-vistoria-api.service';
import { ModeloVistoria } from '../../editar-modelo-vistoria/models/modelo-vistoria';
import { TemplateModeloVistoriaDados } from '../template-modelo-vistoria.resolver';
import { MessageService } from '@services/message.service';

@Component({
  selector: 'app-template-modelo-vistoria',
  standalone: false,
  templateUrl: './template-modelo-vistoria.component.html',
  styleUrl: './template-modelo-vistoria.component.scss'
})
export class TemplateModeloVistoriaComponent implements OnInit {

  protected id: number;
  html = '';
  salvando = false;
  modelo!: ModeloVistoria;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modeloVistoriaApiService: ModeloVistoriaApiService,
    private messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.id = Number(this.route.snapshot.params['id']);

    this.route.data.subscribe((data: Data) => {
      const dados = data['dados'] as TemplateModeloVistoriaDados;
      this.html = dados.template.html;
      this.modelo = dados.modelo;
    });
  }

  public salvar(): void {
    const erro = this.validar();
    if (erro) {
      this.messageService.showToastWarning(erro);
      return;
    }

    // Sequencial, não forkJoin: as duas chamadas escrevem no mesmo ModeloVistoria em
    // transações separadas, e RepositoryBase.Update marca a entidade inteira como
    // modificada — em paralelo, quem commitar por último regrava por cima os campos que
    // a outra chamada acabou de salvar (ex: sobrescreve o HTML com a versão antiga).
    this.salvando = true;
    this.modeloVistoriaApiService.editar(this.id, this.modelo).pipe(
      switchMap(() => this.modeloVistoriaApiService.salvarTemplateHtml(this.id, this.html)),
    ).subscribe({
      next: () => {
        this.messageService.showToastSuccess('Template salvo com sucesso');
        this.salvando = false;
      },
      error: () => { this.salvando = false; }
    });
  }

  public voltar(): void {
    this.router.navigate(['/vistoria/modelos', this.id, 'editar']);
  }

  private validar(): string | null {
    if (!this.html?.trim()) return 'HTML do template não pode ser vazio';

    if (this.modelo.campos.some(c => !c.nome?.trim())) return 'Todos os campos do relatório precisam ter um nome';

    return null;
  }
}
